import { useCallback, useEffect } from 'react';
import { marketplaceIntegration } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';
import { PAGE, SESSION_STATE_KEY } from '../../constants';
import { useBriefData } from '../useBriefData';

const { reportBriefSubmitted } = marketplaceIntegration;

const useRoot = ({ logoMakerConfig }) => {
    const { briefData, briefId, setBriefData, page, setPage } =
        useBriefData(logoMakerConfig);

    useEffect(() => {
        window.sessionStorage.setItem(
            SESSION_STATE_KEY,
            JSON.stringify({ briefData, briefId, page })
        );
    }, [briefData, briefId, page]);

    const handleShortBriefSubmit = useCallback(() => {
        reportBriefSubmitted();
        setPage(PAGE.LISTING);
    }, [setPage]);

    return {
        page,
        briefData,
        setBriefData,
        briefId,
        handleShortBriefSubmit,
    };
};

export default useRoot;
